var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgHomepageSubjectBiology = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 37,
  height: 37,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.723 15.417c.568 0 1.028.46 1.028 1.028V31.86a1.028 1.028 0 0 1-2.056 0V16.445c0-.568.46-1.028 1.028-1.028Z",
  fill: "#FFF"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M26.667 5.85c-1.782 2.518-3.594 5.687-3.983 8.146-.193 1.22-.005 2.06.47 2.598.481.546 1.482 1.041 3.514 1.041 2.031 0 3.032-.495 3.513-1.04.475-.54.663-1.38.47-2.6-.39-2.457-2.202-5.627-3.984-8.146ZM25.03 4.604a2.004 2.004 0 0 1 3.275 0c1.809 2.548 3.903 6.083 4.376 9.07.239 1.51.093 3.085-.957 4.278-1.044 1.185-2.758 1.738-5.056 1.738-2.299 0-4.013-.553-5.057-1.738-1.05-1.193-1.196-2.767-.957-4.278.472-2.987 2.567-6.522 4.376-9.07Z",
  fill: "#FFF"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.64 19.245V5.275h2.056v13.97h-2.055Z",
  fill: "#FFF"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.863 10.951a1.028 1.028 0 0 1 1.454 0l4.075 4.075a1.028 1.028 0 1 1-1.454 1.454l-4.075-4.075a1.028 1.028 0 0 1 0-1.454Z",
  fill: "#FFF"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M31.472 10.951a1.028 1.028 0 0 0-1.453 0l-4.075 4.075a1.028 1.028 0 0 0 1.454 1.454l4.074-4.075a1.028 1.028 0 0 0 0-1.454ZM7.506 20.6c1.744 2.546 4.088 5.345 6.258 6.563 1.077.605 1.93.72 2.6.462.68-.262 1.491-1.029 2.196-2.934.705-1.905.588-3.016.243-3.657-.34-.632-1.063-1.1-2.274-1.342-2.44-.488-6.042.112-9.023.909Zm-1.735 1.104a2.004 2.004 0 0 1 1.136-3.07c3.018-.813 7.06-1.55 10.025-.957 1.5.3 2.926.983 3.68 2.382.75 1.39.673 3.19-.124 5.345-.798 2.155-1.912 3.571-3.385 4.139-1.483.57-3.01.162-4.345-.587-2.636-1.48-5.225-4.67-6.987-7.252Z",
  fill: "#FFF"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.711 26.214 6.61 21.366l.714-1.928 13.101 4.848-.713 1.928Z",
  fill: "#FFF"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.629 26.874a1.028 1.028 0 0 1 .504-1.363l5.236-2.407a1.028 1.028 0 1 1 .858 1.867l-5.235 2.408a1.028 1.028 0 0 1-1.363-.505Z",
  fill: "#FFF"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.96 17.869a1.028 1.028 0 0 0-.505 1.363l2.407 5.235a1.028 1.028 0 1 0 1.868-.859l-2.408-5.235a1.028 1.028 0 0 0-1.363-.505ZM18.506 24.741c.18-.538.762-.83 1.3-.65l6.985 2.328a1.028 1.028 0 0 1-.65 1.95l-6.985-2.328a1.028 1.028 0 0 1-.65-1.3Z",
  fill: "#FFF"
})));
export default SvgHomepageSubjectBiology;